export default "__VITE_ASSET__Bxbk0Hbq__"